import React from 'react';
import useAuth from '../hooks/useAuth';

const EditItem = ({ product, index }) => {

    const { setEditProducts } = useAuth()

    const editItem = (index, newValue) => {
        setEditProducts(prevItems => {
            const newItems = [...prevItems];
            newItems[index] = newValue;
            return newItems;
        });
    }

    return (
        <div className="">
            <div className="d-none d-lg-block">
                <div className="d-flex justify-content-between align-items-center">
                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-1 fw-bold py-2 ps-2">{product.code}</div>
                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-3 fw-bold p-2">{product.name}</div>
                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-1 fw-bold py-2 text-center">{product.stock}</div>

                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-2 fw-bold py-2 text-center">{product.demand}</div>

                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-2 fw-bold py-2">
                        <input id={`${product.code}-delivered`} onChangeCapture={(e) => editItem(index, {
                            code: product.code,
                            delivered: parseInt(e.target.value) || 0,
                            demand: product.demand,
                            name: product.name,
                            stock: product.stock,
                            time: new Date().toLocaleTimeString(),
                            remark: document.getElementById(`${product.code}-remark`).value
                            // unit: document.getElementById(`${product.code}-unit`).querySelector('option:checked').value
                        })} defaultValue={product.delivered} min='0' placeholder='Select' style={{ width: '80px', height: '18px' }} className='mx-auto d-block text-center' type='number' />
                    </div>

                    <div style={{ borderRight: '1px solid #46A4F2', fontSize: '12px' }} className="col-md-1 fw-bold py-2 text-center">{product.demand - product.delivered || 0}</div>

                    <div style={{ fontSize: '12px' }} className="col-md-2 fw-bold py-2">
                        <input id={`${product.code}-remark`} onChangeCapture={(e) => editItem(index, {
                            code: product.code,
                            delivered: parseInt(document.getElementById(`${product.code}-delivered`).value) || 0,
                            demand: product.demand,
                            name: product.name,
                            stock: product.stock,
                            time: new Date().toLocaleTimeString(),
                            remark: e.target.value || ""
                            // document.getElementById(`${product.code}-unit`).querySelector('option:checked').value
                        })} defaultValue={product.remark} placeholder='Remark' style={{ 
                            // width: '80px', 
                            height: '18px' }} className='mx-auto d-block' type='text' />
                    </div>  

                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center d-lg-none">
                <div style={{ borderRight: '1px solid #46A4F2', fontSize: '11px' }} className="col-8 py-1 px-2"><i><small style={{ fontSize: '10px', color: '#6d9dd5' }}>{product.code}</small></i>
                    <br /><b>{product.name}</b>
                    <br /><span className='text-brand fw-bold'>Closing Stock:</span> {product.stock}
                    <br /><span className='text-brand fw-bold'>Next Day Demand:</span> {product.demand}
                    <br /><div className="d-flex">
                    <span className='text-brand fw-bold d-flex justify-content-center align-items-center'>Remark:</span><input id={`${product.code}-remark`} onChangeCapture={(e) => editItem(index, {
                            code: product.code,
                            delivered: parseInt(document.getElementById(`${product.code}-delivered`).value) || 0,
                            demand: product.demand,
                            name: product.name,
                            stock: product.stock,
                            time: new Date().toLocaleTimeString(),
                            remark: e.target.value || ""
                            // document.getElementById(`${product.code}-unit`).querySelector('option:checked').value
                        })} defaultValue={product.remark} placeholder='Feedback' style={{ 
                            // width: '80px', 
                            height: '18px' }} className='mx-auto d-block' type='text' />
                    </div>
                </div>

                <div style={{fontSize: '12px'}} className="col-2 fw-bold px-1">
                <input id={`${product.code}-delivered`} onChangeCapture={(e) => editItem(index, {
                            code: product.code,
                            delivered: parseInt(e.target.value) || 0,
                            demand: product.demand,
                            name: product.name,
                            stock: product.stock,
                            time: new Date().toLocaleTimeString(),
                            remark: document.getElementById(`${product.code}-remark`).value
                            // unit: document.getElementById(`${product.code}-unit`).querySelector('option:checked').value
                        })} defaultValue={product.delivered} min='0' placeholder='Select' style={{ width: '80px', height: '18px' }} className='mx-auto d-block text-center' type='number' />
                </div>

                <div style={{ fontSize: '12px' }} className="col-2 fw-bold py-2 text-center">
                    {product.demand - product.delivered || 0}
                </div>

            </div>
        </div>
    );
};

export default EditItem;